import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React, {useState} from 'react';

import BLASTModal from 'search/blast/BLASTModal';
import {BlastModalTrigger, trackBlastModalOpen} from 'search/blast/BLASTTracking';
import {BLASTFilter, Filter, FilterKey, Operator, SearchParams} from 'search/SearchConstants';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import {GRAY_LIGHT} from 'ui-library/Colors';
import runModal from 'ui-library/runModal';

import {mergeBLASTFilter} from './BLASTUtil';

export interface BLASTButtonProps {
  className?: string;
  onUpdateFilters: (filters: Array<Filter>) => void;
  searchParams: SearchParams;
}

export default function BLASTButton({
  className,
  onUpdateFilters,
  searchParams,
}: BLASTButtonProps): JSX.Element | null {
  const [hover, setHover] = useState(false);
  return (
    <Button
      buttonStyle={ButtonStyle.TERTIARY_WHITE}
      className={classNames(css(styles.button), className, {
        [css(styles.buttonHover)]: Boolean(hover),
      })}
      size={ButtonSize.SMALL}
      icon="blast"
      onClick={() => {
        trackBlastModalOpen(BlastModalTrigger.BLAST_SEARCH);
        runModal(BLASTModal, {
          initialFilter: {
            key: FilterKey.BLAST,
            operator: Operator.BLASTN,
            value: {textSequences: [], apiIdentifiers: []},
          },
          onRequestClose: () => {},
          onRequestSubmit: (newFilter: BLASTFilter): void => {
            onUpdateFilters(mergeBLASTFilter(searchParams, newFilter).filters);
          },
        });
      }}
      onMouseOver={() => {
        setHover(true);
      }}
      onMouseOut={() => {
        setHover(false);
      }}
      dataTestAttrs={{component: 'BLASTButton', element: 'root'}}
    />
  );
}

// The SMALL button is slightly too big to fit inside the search box, but the MINI button makes it impossible
// to tell what icon the molecule is. So we squish the padding slightly.
const styles = StyleSheet.create({
  button: {
    border: 'none',
    borderRadius: '2px',
    margin: '2px',
    height: '24px',
    padding: '2px 6px',
  },
  buttonHover: {
    backgroundColor: GRAY_LIGHT,
  },
});
